export default "__VITE_ASSET__DUSUFWCV__"